<template>
    <div>
        <div class="form-group m-form__group row"  :class="{'has-danger': form.errors.has(form.active)}">
            <label class="col-lg-3 col-form-label">Active</label>
            <div class="col-md-9" >
                <span class="m-switch m-switch--icon">
                    <label>
                        <input type="checkbox" :checked="form.active" ref="input" @click="form.active = !form.active;">
                        <span></span>
                    </label>
                </span>
            </div>
        </div>

        <form-input :form="form" property="image" label="Photo">
            <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
        </form-input>

        <form-input :form="form" property="name"></form-input>

        <form-input :form="form" property="slug" label="Slug"></form-input>
    </div>
</template>

<style>
    .form-tabs .nav-item:hover{
        cursor: pointer;
    }
</style>

<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';

export default {
    mixins: [Model,UploadFiles],
    data() {
        return {
            method: '/api/teams',
            active: 'form',
            form: new Form(() => {
                return {
                    active:true,
                    name: '',
                    slug: '',
                    description: {},
                    image: {
                        alt: {}
                    },
                };
            }),

        };
    },

    mounted()
    {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });
    },

};
</script>



// WEBPACK FOOTER //
// resources/js/forms/Team.vue